export const getLimitDate = (startDate: Date | null, endDate: Date | null, isStartDate: boolean): Date => {
    if (isStartDate) {
        if (endDate !== null) {
            return endDate;
        } else {
            let lastDate = new Date();
            lastDate.setFullYear(lastDate.getFullYear() + 100);

            return lastDate;
        }
    } else {
        if (startDate !== null) {
            return startDate;
        } else {
            let firstDate = new Date();
            firstDate.setFullYear(firstDate.getFullYear() - 100);

            return firstDate;
        }
    }
}